import { CheckboxProps as MUICheckboxProps } from '@mui/material/Checkbox'
import tw, { styled } from 'twin.macro'

export const StyledMessage = styled.label((props: MUICheckboxProps | any) => [
  tw`mt-1 text-monochrome-600 text-xs`,
  props['data-haserror'] && tw`text-accent-two-900`,
  props['data-hasfocus'] && tw`text-monochrome-900`,
])
